module.exports = {
  "default": require("core-js/library/fn/object/values"),
  __esModule: true
};